define(['edge/platform/base/BaseCtrl', 'underscore','edge/platform/util/FunUtil'], (BaseCtrl, _, Fun)=> {
    /*
     The information being collected on this page is covered by PCI-DSS.
     It is the customer's responsibility to ensure that any security/data protection measures that are required are implemented.
     Data from this page should only ever be transmitted over HTTPS.
     */
    const fn = ($filter, $scope, StateUtils, ModalService, submissionViewModel, CustomPaymentService, $state, $q, CCDEV_APPID, CCDEV_APPKEY, CCDEV_MID, CCDEV_PAYMENTID, CCDEV_PAYMENTURL, InputValidationService)=> {
        const ctrl = Object.create(BaseCtrl);
        const submissionVM = submissionViewModel();
        const flowModel = StateUtils.activeDataForState(true).flowModel;
        const numberOfPayments = StateUtils.activeDataForState(true).numberOfPayments;
        const chosenQuoteId = StateUtils.activeDataForState(true).model.value.quoteData.offeredQuotes[0].publicID;
        var messagePoster, paymentModal;

        ctrl.init = ()=> {
            $scope.dateSelected = {
                value : ''
            };
            $scope.isNameValid = true
            $scope.quoteID = submissionVM.value.quoteID;


            $scope.ccDetails = {};
            submissionVM.bindData.chosenQuote.value = chosenQuoteId;
            $scope.view = submissionVM.bindData;
            $scope.view.paymentDetails.value = $scope.view.paymentDetails.value || {};
            $scope.view.paymentDetails.paymentMethod.value = 'creditcard';

            $scope.view.selectedPaymentPlan.value = '';

            $scope.view.paymentDetails.creditCardData = {};
            $scope.policyEffectiveDay = new Date(submissionVM.draftData.periodStartDate.value).getDate();
            $scope.dateSelected.value = $scope.policyEffectiveDay
            if($scope.view.paymentDetails.paymentEffectiveDate && $scope.view.paymentDetails.paymentEffectiveDate.value){
                $scope.dateSelected.value = $scope.view.paymentDetails.paymentEffectiveDate.value;
            }
            $scope.drivers = submissionVM.value.draftData.lobs.personalAuto.drivers;

            $scope.numberOfPayments = numberOfPayments;

            $scope.paymentPlans = ctrl.getPaymentPlans($scope.numberOfPayments);


            if ($scope.paymentPlans.length === 1) {
                $scope.view.selectedPaymentPlan.value = $scope.paymentPlans[0].billingId;
            }

            //$scope.paymentFrequency = $scope.view.paymentDetails.paymentFrequency.value.code || "";
           

            $scope.paymentPlans = ctrl.filterPaymentPlans();

            $scope.chosenQuoteData = _.findWhere(submissionVM.quoteData.offeredQuotes.value, {publicID: chosenQuoteId});

        };


        $scope.getPaymentFrequency = ()=> {
            var isMonthly = false;
            angular.forEach(submissionVM.value.bindData.paymentPlans,function(x){
                if($scope.view.selectedPaymentPlan.value === x.billingId){
                    if(x.numberOfInstallments > 1){
                        isMonthly = true;
                    }
                    else
                    {
                        isMonthly = false;
                    }
                }
            });
            return isMonthly;
        };

        ctrl.getPaymentPlans = (numPayments)=> {
            const allPlans = $scope.view.value.paymentPlans;
            return allPlans;
             //return ctrl.filterPaymentPlans(allPlans);
           /* if (numPayments > 1) {

                return ctrl.filterPaymentPlans(allPlans);
            }*/

            /*return [
                _.find(allPlans, plan => plan.installment.amount === 0)
            ];*/
        };

        ctrl.getAmount = (quoteAmount)=> {
            return $filter('gwCurrency')(quoteAmount);
        };

        ctrl.cancel = function () {
            flowModel.cancel(submissionVM);
        };


        /* ctrl.filterPaymentPlans = (allPlans)=>{

            allPlans = _.filter(allPlans,(plans) => {
                return ( (plans.invoiceFrequency == "monthly" || plans.invoiceFrequency == "everysixmonths") &&
                (plans.name.indexOf("EFT/RCC") > 0  && plans.name.indexOf("Book Roll") <= 0 && plans.name.indexOf("Ann") <= 0) )
            });

            _.forEach($scope.drivers, function(driver){
                if(driver.needSR22){
                    allPlans = _.filter(allPlans,(plans) => {
                        return plans.name.indexOf("SR22") > 0
                    });
                }else{
                    allPlans = _.filter(allPlans,(plans) => {
                        return plans.name.indexOf("SR22") <= 0
                    });
                }
            });

            return allPlans;
        }; */

        ctrl.filterPaymentPlans = ()=>{

                    var paymentPlans = $scope.paymentPlans;
                     var aDriverWithSR22 = false;
                    _.forEach($scope.drivers, function(driver){
                    if(driver.needSR22){aDriverWithSR22=true;}});
            
                        if (aDriverWithSR22){
                               if(submissionVM.value.draftData.termType.toLowerCase() == "annual"){
                                 paymentPlans = _.filter($scope.paymentPlans,(plans) => {
                                 return ( (plans.name.includes("12 mo") && plans.name.includes("SR-22")) || plans.name.includes("Full Pay"))});
                                }
                           		else if (submissionVM.value.draftData.termType.toLowerCase() == "halfyear"){
                               		paymentPlans = _.filter($scope.paymentPlans,(plans) => {
                               		return ((plans.name.includes("6 mo") && plans.name.includes("SR-22")) || plans.name.includes("Full Pay"))});
                                }
                        }else if(submissionVM.value.draftData.termType.toLowerCase() == "annual"){
                            paymentPlans = _.filter($scope.paymentPlans,(plans) => {
                                return ((plans.name.includes("12 mo") && !plans.name.includes("SR-22"))  || plans.name.includes("Full Pay"))
                            });
                        }else if(submissionVM.value.draftData.termType.toLowerCase() == "halfyear"){
                            paymentPlans = _.filter($scope.paymentPlans,(plans) => {
                                return (( plans.name.includes("6 mo")  && !plans.name.includes("SR-22")) || plans.name.includes("Full Pay"))
                            });
                        }
                     return paymentPlans
            }; 

        ctrl.openPaymentWindow = function (onetimeInd) {
            $scope.oneTime = onetimeInd;

            /**
             * THIS IS THE PAYLOAD BEING SENT TO PAYMENT PAGE
             */
            var message = JSON.stringify({
                'transaction_type': 'CCTATOKENIZE',
                'app_id': CCDEV_APPID,
                'mid_id': CCDEV_MID,
                'payment_id': CCDEV_PAYMENTID,
                'app_key': CCDEV_APPKEY,
                'redirect_url': '',
                'cardholder_name': '',
                'merchant_ref': $scope.quoteID,
                'terms': '<span class="sup">‡</span>Terms and Conditions</a> | <a href="http://carolinas.aaa.com/about/privacypolicy">Privacy Policy</a> | <a href="https://join.carolinas.aaa.com/security.htm">Your information is secure.</a>',
                'billing_address': {
                    'street': submissionVM.value.draftData.accountHolder.primaryAddress.addressLine1, //string
                    'city': submissionVM.value.draftData.accountHolder.primaryAddress.city, //string
                    'state_prov': submissionVM.value.draftData.accountHolder.primaryAddress.state, //string
                    'zip': submissionVM.value.draftData.accountHolder.primaryAddress.postalCode, //number,
                    'email': submissionVM.value.draftData.accountHolder.emailAddress1
                }
            });

            // Create modal
            if( !paymentModal ) {
                var modal = document.createElement('div');
                modal.id = 'modal';
                modal.innerHTML = CCDEV_PAYMENTURL;
                    document.body.appendChild(modal);
                    paymentModal = document.getElementById('modal');


            }

            var paymentWindow = document.getElementById('payment-page');
            messagePoster = setInterval(function() {
                paymentWindow.contentWindow.postMessage(message, '*');
            }, 100);

            function validateInputs (inputsToValidate, scopeVar) {
                let inputValidationData = [];
                inputValidationData = InputValidationService.isInputValid(inputsToValidate)
                if(!inputValidationData[0] && inputValidationData[1].length > 0){
                    for (let i=0; i<inputValidationData[1].length; i++){
                        scopeVar[inputValidationData[1][i]] = ''
                        $scope.isNameValid = false;
                    }
                }else{
                    $scope.isNameValid = true;
                }
            }


//  Consider events originated form Pay Test/Production sites only
//  Bypass any other events like Google Tag related events
//  AB - 01/19/2021
        var eventHandler = function (event) {
            if (event.origin === 'https://paytest.carolinas.aaa.com' || event.origin === 'https://pay.carolinas.aaa.com' ){
            clearInterval(messagePoster);
                if (event.data !== 'close') {
                    if (event.data !== 'stop') {
                    var received_data = JSON.parse(event.data);
                    var infoMarkup = '';
                    for (var key in received_data) {
                        infoMarkup += ('<p>' + key + ': ' + received_data[key] + '</p>');
                        if (key == 'cardholder_name') {
                            $scope.ccDetails.cardHolderName = received_data[key];
                        } else if (key == 'token') {

                            var token_data = JSON.parse(JSON.stringify(received_data[key]));
                            for (ky in token_data) {
                                if (ky == 'value') {
                                    $scope.ccDetails.token = token_data[ky];
                                } else if (ky == 'card_type') {
                                    $scope.ccDetails.cardType = token_data[ky];
                                } else if (ky == 'exp_date') {
                                    $scope.ccDetails.expdateUI = token_data[ky].substring(0, 2) + "/" + token_data[ky].substring(2, 4)
                                    $scope.ccDetails.expiryDate = token_data[ky]
                                } else if (ky == 'token_id') {
                                    $scope.ccDetails.tokenId = token_data[ky];
                                } else if (ky == 'provider_id') {
                                    $scope.ccDetails.providerId = token_data[ky];
                                } else if (ky == 'card_number') {
                                    $scope.ccDetails.cardNumber = token_data[ky];
                                }
                            }
                        } else if (key == 'billing_address') {
                            var address_data = JSON.parse(JSON.stringify(received_data[key]));
                            for (k in address_data) {
                                if (k == 'street') {
                                    $scope.ccDetails.billingStreet = address_data[k];
                                } else if (k == 'city') {
                                    $scope.ccDetails.billingCity = address_data[k];
                                } else if (k == 'state_prov') {
                                    $scope.ccDetails.billingState = address_data[k];
                                } else if (k == 'zip') {
                                    $scope.ccDetails.billingZip = address_data[k];
                                }
                            }
                        }
                    }
                    //$scope.ccDetails.displayName = $scope.ccDetails.cardType+" "+$scope.ccDetails.cardNumber.slice(-4)+" "+$scope.ccDetails.expdateUI;
                    $scope.ccDetails.displayName = $scope.ccDetails.cardType + " " + $scope.ccDetails.cardNumber + " " + $scope.ccDetails.expdateUI;
                    $scope.ccDetails.paymentMethod = "creditcard";

                    if (paymentModal != null) {
                        paymentModal.parentElement.removeChild(paymentModal);
                        paymentModal = null;
                    }

                    $scope.ccDetails.oneTime = false;
                    $scope.ccDetails.nickName = $scope.ccDetails.displayName;
                    $scope.ccDetails.accountNumber = submissionVM.value.draftData.accountNumber;

                    let inputsToValidate = [{'billingStreet' : $scope.ccDetails.billingStreet},
                    {'billingCity' : $scope.ccDetails.billingCity}]
                    validateInputs(inputsToValidate,$scope.ccDetails)
                    if(!$scope.isNameValid){;
                        return
                    } 
                    window.removeEventListener("message", eventHandler);
                    let createInstrument;
                    createInstrument = CustomPaymentService.createPaymentInstrumentForAccount($scope.ccDetails, ['createInstrumentInfo']);
                    ModalService.showProgressDialog('quoteandbind.views.modal.Please wait', createInstrument);
                    $q.when(createInstrument, Fun.setter($scope, 'createInstrumentInfo')).then(function (createInstrument) {

                        if ($scope.ccDetails.token) {
                            $scope.view.paymentDetails.value.creditCardData.displayName = $scope.ccDetails.displayName;
                            $scope.view.paymentDetails.value.creditCardData.cardHolderName = $scope.ccDetails.cardHolderName;
                            $scope.view.paymentDetails.value.creditCardData.cardType = $scope.ccDetails.cardType;
                            $scope.view.paymentDetails.value.creditCardData.expiryDate = $scope.ccDetails.expiryDate;
                            $scope.view.paymentDetails.value.creditCardData.oneTime = $scope.ccDetails.oneTime;
                            $scope.view.paymentDetails.value.creditCardData.nickName = $scope.ccDetails.nickName;
                            $scope.view.paymentDetails.value.creditCardData.token = $scope.ccDetails.token;
                            $scope.view.paymentDetails.value.creditCardData.publicID = $scope.createInstrumentInfo.publicID;
                            $scope.view.paymentDetails.value.creditCardData.cardNumber = $scope.ccDetails.cardNumber;
                            $scope.view.paymentDetails.value.creditCardData.providerId = $scope.ccDetails.providerId;
                            $scope.view.paymentDetails.value.creditCardData.tokenId = $scope.ccDetails.tokenId;

                            if ($scope.view.paymentDetails.paymentType.value.code == 'recurring') {
                                $scope.view.paymentDetails.value.paymentEffectiveDate = $scope.dateSelected.value;
                            }
                            //console.log("After Payment:: ",$scope.view.paymentDetails.paymentType, $scope.view.paymentDetails.value.paymentEffectiveDate);
                            //console.log("SubmissonVM:: ",submissionVM);
                            flowModel.next(submissionVM, true);

                        }
                    });
                    }
                }else if(event.data == 'close'){
                    if(paymentModal != null) {
                        paymentModal.parentElement.removeChild(paymentModal);
                        paymentModal = null;
                    }
                    window.removeEventListener("message", eventHandler);
                }
            }
         };

            window.addEventListener("message", eventHandler );
        };


        ctrl.next = (form)=> {
            form.submitted = true;

            if (!$scope.view.selectedPaymentPlan.value) {
                ModalService.showError(
                    'quoteandbind.controllers.PaymentDetailsCtrl.Please choose a payment plan',
                    'quoteandbind.controllers.PaymentDetailsCtrl.You have not chosen a payment plan');
                return;
            }

            //console.log("date selected",$scope.dateSelected.value);

            // if($scope.getPaymentFrequency() && $scope.dateSelected.value == '')
            // {
            //     return false;
            // }

            // if($scope.getPaymentFrequency()){
            //     $scope.view.paymentDetails.paymentType = 'recurring'
            // }
            // else{
            //     $scope.view.paymentDetails.paymentType = 'billbymail'
            // }

            // Added By : Devnandan (10/05/2021) - DFCT0016957 - QnB Full Pay Payment Plan Mapping is Incorrect
            if (submissionVM.value.bindData.selectedPaymentPlan === _.findWhere($scope.paymentPlans, {'name': 'Full Pay'}).billingId) {
                submissionVM.value.bindData.policyQuotePaymentMethod = 'recurring';
                submissionVM.value.draftData.policyQuotePaymentMethod = 'recurring';

                $scope.view.paymentDetails.paymentType = 'recurring'
                submissionVM.value.bindData.paymentDetails.paymentType = 'recurring'

                submissionVM.value.bindData.policyInfoPaymentMethod = 'paid_in_full';
                submissionVM.value.draftData.policyInfoPaymentMethod = 'paid_in_full';
            }
            else if (submissionVM.value.bindData.selectedPaymentPlan === _.findWhere($scope.paymentPlans, {'name': 'Monthly (6 mo)'}).billingId) {
                $scope.view.paymentDetails.paymentType = 'recurring'
                submissionVM.value.bindData.paymentDetails.paymentType = 'recurring'
                submissionVM.value.draftData.policyInfoPaymentMethod = 'recurring';
                submissionVM.value.bindData.policyInfoPaymentMethod = 'recurring';
            }

            ctrl.openPaymentWindow(false);


            if ($scope.view.paymentDetails.paymentMethod.value === 'wire') { //Remove unused payment data to avoid validation exception
                $scope.view.paymentDetails.creditCardData.value = null;
            } else {
                $scope.view.paymentDetails.bankAccountData.value = null;
            }



        };

        return ctrl.create($scope);
    };
    fn.$inject = ['$filter', '$scope', 'StateUtils', 'ModalService', 'submissionViewModel', 'CustomPaymentService', '$state', '$q', 'CCDEV_APPID', 'CCDEV_APPKEY', 'CCDEV_MID', 'CCDEV_PAYMENTID', 'CCDEV_PAYMENTURL','qnb.InputValidationService'];

    return fn;
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/controllers/PaymentDetailsCtrl.js
 **/